var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWatchVideo = function SvgWatchVideo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m482 33.5h-452c-16.54 0-30 13.46-30 30v64c0 8.28 6.72 15 15 15h482c8.28 0 15-6.72 15-15v-64c0-16.54-13.46-30-30-30z",
    fill: "#6ba7ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 63.5v64c0 8.28-6.72 15-15 15h-241v-109h226c16.54 0 30 13.46 30 30z",
    fill: "#5e69e2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 112.5v336c0 16.57 13.43 30 30 30h452c16.57 0 30-13.43 30-30v-336z",
    fill: "#f9f9f9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m512 112.5v336c0 16.57-13.43 30-30 30h-226v-366z",
    fill: "#e2dff4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m368 414.5c-8.284 0-15-6.716-15-15v-32c0-8.284 6.716-15 15-15s15 6.716 15 15v32c0 8.284-6.716 15-15 15z",
    fill: "#00cb75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447 399.5c0 8.28-6.72 15-15 15h-352c-8.28 0-15-6.72-15-15s6.72-15 15-15h352c8.28 0 15 6.72 15 15z",
    fill: "#ffe278"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m447 399.5c0 8.28-6.72 15-15 15h-176v-30h176c8.28 0 15 6.72 15 15z",
    fill: "#ffb454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.32 251.02c-68.391-45.597-46.044-30.7-96-64-9.937-6.63-23.32.487-23.32 12.48v136c0 12.354 14.141 19.404 24 12l96-72c8.258-6.198 7.934-18.737-.68-24.48z",
    fill: "#ff6378"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m313 275.5-57 42.75v-104.78l56.32 37.55c8.592 5.728 8.96 18.265.68 24.48z",
    fill: "#ff1f3d"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWatchVideo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/watch-video.a8b581ce.svg";
export { ForwardRef as ReactComponent };